import {REPORT_ACTION_EVENT_TYPES} from '@/models/ReportModel';

const EventsModule = {
    namespaced: true,
    state: () => ({
        events: [],
    }),
    getters: {
        getEvents(state) {
            return state.events
        },
        getReportActionCount(state) {
            return (state.events || []).filter((event) =>
                REPORT_ACTION_EVENT_TYPES.includes(Number(event.type))
            ).length;
        },
    },
    mutations: {
        setEvents(state, payload) {
            state.events = payload
        },
    },
    actions: {
        setEvents(context, payload) {
            context.commit('setEvents', payload);
        },
    },
}

export default EventsModule;
